export default {"src":"/_next/static/media/solveproblems.e0a935ab.svg","height":61,"width":59,"blurWidth":0,"blurHeight":0};